import i18next from "i18next";
import { colors } from "../constants/colors";

/* FILE EXTENSIONS FOR IDENTIFICATION */
export const VALID_FILES_EXTENSION_ARR = ["png", "jpg", "jpeg", "pdf", "doc", "docx"];
export const IMG_EXTENSION_ARR = ["png", "jpg", "jpeg"];
export const VID_EXTENSION_ARR = ["mp4"];
export const PDF_EXTENSION_ARR = ["pdf"];
export const TXT_EXTENSION_ARR = ["txt"];
export const DOC_EXTENSION_ARR = ["doc", "docx"];
export const XLS_EXTENSION_ARR = ["xls", "xlsx", "csv"];
export const PPT_EXTENSION_ARR = ["ppt", "pptx"];
export const DOCUMENT_EXTENSION_ARR = ["pdf", "doc", "docx", "xls", "xlsx", "csv", "ppt", "pptx"]
export const ALL_EXTENSION_ARR = ["pdf", "doc", "docx", "xls", "xlsx", "csv", "ppt", "pptx","png", "jpg", "jpeg"]
/* FILE EXTENSIONS FOR IDENTIFICATION */

/* function definition to disable the number change using mouse scroll */
export const disableOnWheel = (e) => {
  e.currentTarget.blur();
};
/* function definition to disable the number change using mouse scroll */

/* For generating file preview from file of type image */
export const readImageFileAsync = async (file) => {
  return new Promise(async (resolve, reject) => {
    let reader = new FileReader();

    reader.onload = () => {
      resolve(reader.result);
    };

    reader.onerror = reject;

    reader.readAsDataURL(file);
  });
};
/* For generating file preview from file of type image */

/* Function definition to get the file extension from file name */
export const getFileExtensionFromFileName = (fileName) => {
  let fileExtension = "";

  if (fileName && fileName !== "") {
    let tempFileExtension = fileName.substring(fileName.lastIndexOf(".") + 1);

    if (tempFileExtension && tempFileExtension !== "") {
      fileExtension = tempFileExtension;
      fileExtension = fileExtension.toLowerCase();
    }
  }
  return fileExtension;
};
/* Function definition to get the file extension from file name */

/* Function definition to check if the file type is image */
export const checkIfFileIsTypeImageFromFileName = (fileName) => {
  let isFileTypeImage = false;
  let fileExtension = getFileExtensionFromFileName(fileName);

  if (IMG_EXTENSION_ARR.indexOf(fileExtension) >= 0) {
    isFileTypeImage = true;
  }
  return isFileTypeImage;
};
/* Function definition to check if the file type is image */

/* Function definition to formulate image preview of the attachment */
export const formulateAttachmentPreview = (
  attachmentFileObj,
  attachmentFileName,
  attachmentFileUrl
) => {
  return new Promise(async (resolve, reject) => {
    let fileImagePreview = "";
    if (attachmentFileObj) {
      attachmentFileName = attachmentFileObj.name;
    }
    let isFileTypeImage =
      checkIfFileIsTypeImageFromFileName(attachmentFileName);
    if (attachmentFileObj) {
      fileImagePreview = attachmentFileUrl;
      resolve({ fileImagePreview, isFileTypeImage });
    }
  });
};
/* Function definition to formulate image preview of the attachment */

/* Function definition to check if the file is valid for image attachment */
export const checkIfFileTypeIsValidForImageAttachment = (fileName) => {
  let fileExtension = getFileExtensionFromFileName(fileName);

  let isValidAttachment = false;
  let isInvalidMessage = "";

  if (IMG_EXTENSION_ARR.indexOf(fileExtension) >= 0) {
    isValidAttachment = true;
  } else {
    isInvalidMessage = "Only JPG and PNG file formats are allowed for uploading images.";
  }

  return {
    isValid: isValidAttachment,
    isInvalidMessage,
  };
};
/* Function definition to check if the file is valid for image attachment */

/* Function definition to check if the file is valid for pdf attachment */
export const checkIfFileTypeIsValidForPdfAttachment = (fileName) => {
  let fileExtension = getFileExtensionFromFileName(fileName);

  let isValidAttachment = false;
  let isInvalidMessage = "";

  if (PDF_EXTENSION_ARR.indexOf(fileExtension) >= 0) {
    isValidAttachment = true;
  } else {
    isInvalidMessage = "Only PDF file format is allowed for uploading documents.";
  }

  return {
    isValid: isValidAttachment,
    isInvalidMessage,
  };
};
/* Function definition to check if the file is valid for pdf attachment */

/* Function definition to check if the file is valid for document attachment */
export const checkIfFileTypeIsValidForDocumentAttachment = (fileName) => {
  let fileExtension = getFileExtensionFromFileName(fileName);

  let isValidAttachment = false;
  let isInvalidMessage = "";

  if (DOCUMENT_EXTENSION_ARR.indexOf(fileExtension) >= 0) {
    isValidAttachment = true;
  } else {
    isInvalidMessage = "File format is not allowed for uploading documents.";
  }

  return {
    isValid: isValidAttachment,
    isInvalidMessage,
  };
};
/* Function definition to check if the file is valid for document attachment */

/* Function definition to check if the file is valid for document attachment */
export const checkIfFileTypeIsValidForAllAttachment = (fileName) => {
  let fileExtension = getFileExtensionFromFileName(fileName);

  let isValidAttachment = false;
  let isInvalidMessage = "";

  if (ALL_EXTENSION_ARR.indexOf(fileExtension) >= 0) {
    isValidAttachment = true;
  } else {
    isInvalidMessage = "File format is not allowed. ";
  }

  return {
    isValid: isValidAttachment,
    isInvalidMessage,
    fileExtension
  };
};
/* Function definition to check if the file is valid for document attachment */


export const getUserStatus = (status) => {
  switch (status) {
    case "active":
      return { background: colors.lightTeal, color: colors.darkTeal };

    case "inactive":
      return {
        background: colors.lightPinkishRed,
        color: colors.darkMaroon,
      };

    case "suspended":
      return {
        background: colors.lightPinkishRed,
        color: colors.darkMaroon,
      };

    case "deleted":
      return {
        background: colors.lightPinkishRed,
        color: colors.darkMaroon,
      };

    case "expired":
      return {
        background: colors.black,
        color: colors.white,
      };

    default:
      return {
        background: colors.limeGreen,
        color: colors.darkMaroon,
      };
  }
};

/* Function definition to download attachment url */
export const downloadUrl = (url) => {
  const link = document.createElement("a");
  link.href = url;
  link.download = "document.pdf";
  link.target = "_blank";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
/* Function definition to download attachment url */

/* function definition to trim/sanitize data type from client side */
export const sanitizeDataTypeClientSide = (value) => {
  let tempValue = "";
  if (value && value !== "" && value !== null && value !== undefined) {
    tempValue = value.split(/\s+/).map((word) => word.trim()).join(" ");
  }
  return tempValue;
};


/* function definition to convert time object into 12 hour format */
export const timeObjToDispViewTimeWithSuffix = (timeObj) => {
  let formattedTime = "";

  if (timeObj && timeObj !== "" && timeObj !== null && timeObj !== undefined) {
    const date = new Date(timeObj);
    let hours = date.getHours();
    let minutes = date.getMinutes();

    let suffix = hours >= 12 ? "pm" : "am";

    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? "0" + minutes : minutes;

    formattedTime = hours + ":" + minutes + " " + suffix;
  }
  return formattedTime;
};
/* function definition to convert time object into 12 hour format */

/* function definition to convert time string into 12 hour format */
export const timeStrToDispViewTimeWithSuffix = (timestr) => {
  let formattedTime = "";

  if (timestr && timestr !== "" && timestr !== null && timestr !== undefined) {
    let [hours, minutes, seconds] = timestr.split(":");

    let tempHours = Number(hours);
    let tempMinutes = Number(minutes);

    let suffix = tempHours >= 12 ? "pm" : "am";

    tempHours = tempHours % 12;
    tempHours = tempHours ? tempHours : 12;
    tempMinutes = tempMinutes < 10 ? "0" + tempMinutes : tempMinutes;

    formattedTime = tempHours + ":" + tempMinutes + " " + suffix;
  }
  return formattedTime;
};
/* function definition to convert time string into 12 hour format */

/* function definition to convert 12 hour format time into 24 hour format */
export const timeWithSuffixToDispViewTime24hFormat = (time12h) => {
  let formattedTime = "";

  if (time12h && time12h !== "" && time12h !== null && time12h !== undefined) {
    const [time, suffix] = time12h.split(" ");
    const [hours, minutes] = time.split(":");

    let tempHours = Number(hours);
    let tempMinutes = Number(minutes);

    if (suffix.toLowerCase() === "am" && tempHours === 12)
      tempHours = tempHours - 12;

    if (suffix.toLowerCase() === "pm" && tempHours < 12)
      tempHours = tempHours + 12;

    let stringifiedHours = tempHours.toString();
    let stringifiedMinutes = tempMinutes.toString();

    if (tempHours < 10) stringifiedHours = "0" + stringifiedHours;

    if (tempMinutes < 10) stringifiedMinutes = "0" + stringifiedMinutes;

    formattedTime = stringifiedHours + ":" + stringifiedMinutes + ":00";
  }

  return formattedTime;
};
/* function definition to convert 12 hour format time into 24 hour format */

// get user-rights for crud operation
export const getUserPermissions = (userRole) => {
  switch (userRole) {
    case "admin":
      return {
        canCreate: true,
        canRead: true,
        canUpdate: true,
        canDelete: true,
        canAddStaff: true,
      };
    case "medicalStaff":
      return {
        canCreate: false,
        canRead: true,
        canUpdate: false,
        canDelete: false,
        canAddStaff: false,
      };
    case "staff":
      return {
        canCreate: true,
        canRead: true,
        canUpdate: true,
        canDelete: true,
        canAddStaff: false,
      };
    default:
      return {
        canCreate: false,
        canRead: false,
        canUpdate: false,
        canDelete: false,
        canAddStaff: false,
      };
  }
};

/* function definition to convert the date into ISO format */
export const dateObjToISOFormat = (dateObj) => {
  let formattedDate = "";

  if (dateObj && dateObj !== null && dateObj !== undefined) {
    const tempDateObj = new Date(dateObj);
    // const localOffset = tempDateObj.getTimezoneOffset();
    // tempDateObj.setMinutes(tempDateObj.getMinutes() - localOffset);
    tempDateObj.setHours(0, 0, 0, 0);
    formattedDate = tempDateObj.toISOString();
  }
  return formattedDate;
};
/* function definition to convert the date into ISO format */

/* function definition to get date object to custom date formats */
export const dateObjToDispViewDate = (dateObj, type) => {
  let formattedDate = "";

  if (dateObj && dateObj !== null && dateObj !== undefined) {
    const tempDate = new Date(dateObj);

    const year = String(tempDate.getFullYear());
    let month = String(tempDate.getMonth() + 1);
    let day = String(tempDate.getDate());

    if (month.length < 2) {
      month = "0" + month;
    }

    if (day.length < 2) {
      day = "0" + day;
    }

    formattedDate = getDateBasedOnFormatType(day, month, year, type);
  }

  return formattedDate;
};
/* function definition to get date object to custom date formats */

/* function definition to get the dates based on its type */
const getDateBasedOnFormatType = (day, month, year, type) => {
  let formattedDate = "";
  switch (type) {
    case "ddmmyyyy":
      formattedDate = day + "/" + month + "/" + year;
      break;
    case "mmddyyyy":
      formattedDate = month + "/" + day + "/" + year;
      break;
    case "yyyymmdd":
      formattedDate = year + "/" + month + "/" + day;
      break;
    case "yyyyddmm":
      formattedDate = year + "/" + day + "/" + month;
      break;
    default:
      break;
  }
  return formattedDate;
};
/* function definition to get the dates based on its type */

/* function definition for custom filter in antd-country-phone-input */
export const getPhoneInputFilterOptions = (input, option) => {
  const key = option?.key.toString().toLowerCase();
  const inputText = input.toLowerCase().trim();
  const lastSpaceIndex = key.lastIndexOf(" ");

  const name = key.substring(0, lastSpaceIndex);
  const code = key.substring(lastSpaceIndex + 1);
  return name.startsWith(inputText) || code.startsWith(inputText);
};
/* function definition for custom filter in antd-country-phone-input */

/* function definition to get the active inactive color */
export const getColorBasedOnStatus = (status) => {
  switch (status) {
    case true:
      return { background: colors.lightTeal, color: colors.darkTeal };

    case false:
      return {
        background: colors.lightPinkishRed,
        color: colors.darkMaroon,
      };

    default:
      break;
  }
};
/* function definition to get the active inactive color */


export const getStatusNameInArabicAsWell = (status) => {
  switch (status) {
    case "active":
      return i18next.t("CommonUtils.active");

    case "inactive":
      return i18next.t("CommonUtils.inactive")

    case "suspended":
      return i18next.t("CommonUtils.suspended")

    case "deleted":
      return i18next.t("CommonUtils.delete")

    case "expired":
      return i18next.t("CommonUtils.expired")

    default:
      return i18next.t("CommonUtils.active");
  }
};




/* validator function to anly allow english */
export const validatorFunctionToAllowOnlyEnglish = (title) => {
  return (_, value) => {
    const regEx = /[^a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/? ]/g
    if (value && regEx.test(value)) {
      return Promise.reject(`${title} ${i18next.t("CommonUtils.inEnglish")}`);
    }
    return Promise.resolve();
  }
}
/* validator function to anly allow english */